// extracted by mini-css-extract-plugin
export default {"dotGroup":"CarouselMobile_dotGroup__3lxoa"};